import { FieldPattern } from '..';

import { STATE_ASYNC_SELECT } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class StatesComboBoxField extends DependentField {
  readonly type: string = STATE_ASYNC_SELECT;
  searchKey: string;
  enableDefaultSuggestion: boolean;
  dependentFields: Array<string>;
  isFieldDisabled: boolean;
  mobilePlaceholder: string;

  constructor(stateFieldData: FormFieldsType, initialValue: string) {
    super(stateFieldData, initialValue);
    this.searchKey = stateFieldData.search_key ?? '';
    this.enableDefaultSuggestion =
      stateFieldData.enable_default_suggestion ?? false;
    this.dependentFields = stateFieldData.dependent_fields ?? [];
    this.isFieldDisabled = false;
    this.mobilePlaceholder = stateFieldData.mobile_placeholder ?? '';
  }

  match<T>(p: FieldPattern<T>): T {
    return p.StatesComboBoxField(this);
  }
}

export default StatesComboBoxField;
